import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

export const VirtualDspCampaignQuerySchema = z.object({
  mediaItemId: z.string(),
});

export const VirtualDspCampaignResponseSchema = createResponseSchema(
  z.object({
    id: z.string(),
    mediaItemId: z.string(),
  }),
);
